export default function hasStringAfterColon(input: string) {
  const index = input.indexOf(':');
  return index !== -1 && index < input.length - 1;
}
